import { useQueryClient } from '@tanstack/react-query'
import { DeleteIcon } from '@shipt/design-system-icons'
import { TextButton } from '@shipt/design-system-buttons'
import { useDeleteBuyAgainProduct } from '@/features/shop/services/Search/useDeleteBuyAgainProduct'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { useStoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { pdpProductQueryOptions } from '@/features/shop/services/Product/queries'

type Props<T extends { id: number; name: string; image: { url: string } }> = {
  product: T
  setSelectedProduct: (product: T) => void
}

export const ProductDetailDeleteBuyAgain = <
  T extends { id: number; name: string; image: { url: string } },
>({
  product,
  setSelectedProduct,
}: Props<T>) => {
  const queryClient = useQueryClient()
  const storeParams = useStoreParams()
  const { onDeleteBuyAgainProduct } = useDeleteBuyAgainProduct()

  const handleUpdateProduct = () => {
    queryClient.setQueryData(
      pdpProductQueryOptions({ productId: product.id, storeParams }).queryKey,
      (prevData) =>
        prevData?.product
          ? { ...prevData, product: { ...prevData.product, bought: false } }
          : undefined,
    )
    setSelectedProduct({ ...product, bought: false })
  }

  const handleDeleteBuyAgainProduct = () => {
    trackElementClicked({
      content: 'remove_product_from_buy_again',
      type: 'button',
    })
    onDeleteBuyAgainProduct(product, handleUpdateProduct)
  }

  return (
    <TextButton onClick={handleDeleteBuyAgainProduct} leadingIcon={DeleteIcon}>
      Remove from Buy Again
    </TextButton>
  )
}
